export enum AssetCategory {
    audiometrie = 'audiometrie',
    customcontroldata = 'customcontroldata',
    externalReferralLetter = 'doorverwijzing_brief',
    homeconsultation = 'homeconsultation',
    huidigeHoortoestelinstellingen = 'huidige_hoortoestelinstellingen',
    incomingReferralAppointment = 'incomingReferralAppointment',
    incomingReferralLetter = 'incomingReferralLetter',
    incomingReferralSupplement = 'incomingReferralSupplement',
    lifestyleAttachment = 'lifestyleAttachment',
    mraAttachment = 'mraAttachment',
    organizationStamp = 'organizationStamp',
    papReport = 'papReport',
    profilePicture = 'profilePicture',
    recipe = 'recipe',
    remMeting = 'rem_meting_en_vrije_veld_spraakaudiometrie',
    removed = 'removed',
    sptReport = 'sptReport',
    trommelvliesfoto = 'trommelvliesfoto',
}
